import AddIcon from '@mui/icons-material/Add'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import React from 'react'

import MenuItem from '@/app/component/atom/menu-item'

type Props = {
  selectExisting: () => void
  startRecording: () => void
  startUpload: (filter: string) => void
}

type Option =
  | {
      action: 'select'
      label: string
      tooltip: string
    }
  | {
      action: 'record'
      label: string
      tooltip: string
    }
  | {
      action: 'upload'
      filter: string
      label: string
      tooltip: string
    }

const options: Option[] = [
  {
    action: 'upload',
    label: 'Upload',
    tooltip: 'Upload an audio file',
    filter: 'asIs',
  },
  {
    action: 'record',
    label: 'Record',
    tooltip: 'Record audio using your microphone',
  },
  {
    action: 'select',
    label: 'Select existing',
    tooltip: 'Choose from files you already uploaded',
  },
]

const UploadButton: React.FC<Props> = (props) => {
  const { selectExisting, startRecording, startUpload } = props
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)

  const handleMenuOpen = () => setOpen(true)

  const handleMenuClose = () => setOpen(false)

  const handleMenuItemClick = (option: Option) => {
    switch (option.action) {
      case 'record':
        startRecording()
        break
      case 'upload':
        startUpload(option.filter)
        break
      case 'select':
        selectExisting()
        break
      default:
        break
    }
    handleMenuClose()
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
      <Button
        data-testid="upload-audio-button"
        color="primary"
        ref={anchorRef}
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        startIcon={<AddIcon />}
        onClick={handleMenuOpen}
      >
        Add audio
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        slotProps={{
          list: {
            'aria-labelledby': 'upload-audio-button',
          },
        }}
        onClose={handleMenuClose}
      >
        {options.map((option, index) => (
          <MenuItem key={index} tooltip={option.tooltip} onClick={() => handleMenuItemClick(option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}

export default UploadButton
